// throwing up the validation that an empty definition was valid CCSEARCH-4472
export const removeInvisibleCharacters: (str: string) => string = (str: string): string => {
	return str.replace(/[\u200c]/g, '');
};
